<template>
  <div class="create-car" v-loading="oLoading.detail">
    <QS-scroller-box>
      <QS-h3-title>
        <template slot="title">{{ pageTitle }}</template>
        <div class="splitline" />
      </QS-h3-title>
      <el-collapse v-model="activeNames">
        <el-collapse-item
          v-if="action === 'confirmCarInStore'"
          title="首次入库车况验收"
          name="car_condtion"
        >
          <div>
            <el-form :model="carInfo" ref="confirmCarInStore">
              <column-box>
                <el-form-item
                  prop="appearanceState"
                  :label="'外观' + columnSeparator"
                >
                  <el-select
                    v-model="carInfo.appearanceState"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option
                      v-for="item in appearanceList"
                      :label="item.label"
                      :value="item.value"
                      :key="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  prop="chassisState"
                  :label="'底盘' + columnSeparator"
                >
                  <el-select
                    v-model="carInfo.chassisState"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option
                      v-for="item in chassisList"
                      :label="item.label"
                      :value="item.value"
                      :key="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </column-box>
            </el-form>
          </div>
        </el-collapse-item>
        <el-collapse-item title="基础信息" name="car_base_info">
          <div class="car-info">
            <div class="zitem-box">
              <div class="zitem">
                <div class="label">
                  <div class="tar">
                    <el-popover
                      placement="top-start"
                      title="温馨提示"
                      width="220"
                      trigger="hover"
                      :content="uploadCommonTip"
                    >
                      <i
                        slot="reference"
                        class="el-icon-question"
                        style="
                          color: #c8c9cc;
                          font-size: 16px;
                          padding-right: 3px;
                        "
                      /> </el-popover
                    >{{ `上传证件照片${columnSeparator}` }}
                  </div>
                  (OCR自动识别信息)
                </div>
                <div class="content">
                  <!-- 行驶证主页 -->
                  <div class="citem mr16">
                    <div class="upload">
                      <UploadCommon
                        ref="drivingMainRef"
                        :fileList="drivingImg.main"
                        :class="RedBlod('main')"
                        fileTitle="行驶证主页"
                        isAlone
                        @uploadSuccess="drivingImgMainSuccess"
                        :sizeType="4"
                        commonUpload
                        group="vehicle"
                        code="vehicle_driving_license_pic"
                      ></UploadCommon>
                    </div>
                    <div class="map mr16">
                      <img src="@/assets/img/driving_main.png" alt="示例图" />
                      <p class="txt">示例图</p>
                    </div>
                  </div>
                  <!-- 行驶证副页 -->
                  <div class="citem mr16">
                    <div class="upload">
                      <UploadCommon
                        ref="drivingBackRef"
                        :fileList="drivingImg.back"
                        :class="RedBlod('back')"
                        fileTitle="行驶证副页"
                        isAlone
                        :sizeType="4"
                        @uploadSuccess="drivingImgBackSuccess"
                        commonUpload
                        group="vehicle"
                        code="vehicle_driving_license_attach_pic"
                      ></UploadCommon>
                    </div>
                    <div class="map mr16">
                      <img src="@/assets/img/driving_back.png" alt="示例图" />
                      <p class="txt">示例图</p>
                    </div>
                  </div>
                  <!-- 行驶证副页背面 -->
                  <div class="citem mr16">
                    <div class="upload">
                      <UploadCommon
                        ref="drivingViceBackRefs"
                        fileTitle="副页背面"
                        :fileList="drivingImg.viceBack"
                        isAlone
                        :sizeType="4"
                        commonUpload
                        group="vehicle"
                        code="vehicle_driving_license_attach_back_pic"
                      >
                      </UploadCommon>
                    </div>
                    <div class="map mr16">
                      <img
                        src="@/assets/img/driving_vice_back.png"
                        alt="示例图"
                      />
                      <p class="txt">示例图</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <el-form ref="carInfoRef" :model="carInfo" :rules="carInfoRules">
              <column-box label-width="120px">
                <template slot="header">
                  <el-form-item
                    prop="deptId"
                    :class="RedBlod('deptId')"
                    :label="`所属部门${columnSeparator}`"
                  >
                    <DeptSelect
                      v-model="carInfo.deptId"
                      filterable
                      clearable
                      isAll
                    />
                  </el-form-item>
                  <el-form-item
                    prop="vin"
                    :class="RedBlod('vin')"
                    :label="'VIN码' + columnSeparator"
                  >
                    <el-input
                      v-model="carInfo.vin"
                      v-uppercase="true"
                      placeholder="请输入"
                      maxlength="17"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <CarBrandSeriesModel
                    v-model="brandSeriesModel"
                    :showModel="true">
                  </CarBrandSeriesModel>
                  <el-form-item
                    prop="color"
                    :class="RedBlod('color')"
                    :label="'车身颜色' + columnSeparator"
                  >
                    <el-select
                      v-model="carInfo.color"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in colorList"
                        :label="item.label"
                        :value="item.value"
                        :key="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    prop="storagePlace"
                    :class="RedBlod('storagePlace')"
                    :label="'存放地' + columnSeparator"
                  >
                    <el-input
                      v-model="carInfo.storagePlace"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    prop="adcode"
                    :label="'运营城市' + columnSeparator"
                  >
                    <el-select
                      v-model="carInfo.adcode"
                      placeholder="请选择"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in cityList"
                        :label="item.city"
                        :value="item.adcode"
                        :key="item.adcode"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    prop="managerId"
                    :label="'所属车管' + columnSeparator"
                  >
                    <el-select
                      :disabled="isHaveDepartment"
                      v-model="carInfo.managerId"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in carTubeList"
                        :label="item.userName"
                        :value="item.id"
                        :key="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    prop="purchaseType"
                    :label="'采购方式' + columnSeparator"
                  >
                    <el-select
                      v-model="carInfo.purchaseType"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in procurementList"
                        :label="item.label"
                        :value="item.value"
                        :key="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    prop="providerId"
                    :label="'车源方' + columnSeparator"
                  >
                    <el-select
                      :disabled="isHaveDepartment"
                      v-model="carInfo.providerId"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in carProviderList"
                        :disabled="item.disabled"
                        :label="item.name"
                        :value="item.id"
                        :key="item.id"
                      ></el-option>
                    </el-select>
                    <!-- 服务商类型： 0 车源方 3 产权方 -->
                    <div>
                      <el-button type="text" @click="handleProviderShow('0')"
                        >新增车源方</el-button
                      >
                    </div>
                  </el-form-item>
                  <el-form-item
                    prop="propertyId"
                    :label="'产权方' + columnSeparator"
                  >
                    <el-select
                      :disabled="isHaveDepartment"
                      v-model="carInfo.propertyId"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in propertyList"
                        :disabled="item.disabled"
                        :label="item.name"
                        :value="item.id"
                        :key="item.id"
                      ></el-option>
                    </el-select>
                    <div>
                      <el-button type="text" @click="handleProviderShow('3')"
                        >新增产权方</el-button
                      >
                    </div>
                  </el-form-item>
                  <el-form-item
                    prop="displayMile"
                    :class="RedBlod('displayMile')"
                    :label="'表显里程' + columnSeparator"
                  >
                    <el-input
                      v-model="carInfo.displayMile"
                      placeholder="请输入里程"
                      v-number:km
                    >
                      <template slot="append"
                        >公里</template
                      >
                    </el-input>
                  </el-form-item>

                  <el-form-item
                    prop="mortgagor"
                    :label="'车辆抵押方' + columnSeparator"
                  >
                    <el-input
                      v-deleteEmoji
                      v-model="carInfo.mortgagor"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                  </el-form-item>
                </template>
              </column-box>
            </el-form>
          </div>
        </el-collapse-item>
        <el-collapse-item title="行驶证信息" name="driver_license_info">
          <div>
            <el-form
              ref="carLicenseInfoRef"
              :model="carLicenseInfo"
              :rules="carLicenseRules"
            >
              <column-box label-width="140px">
                <template slot="header">
                  <el-form-item
                    prop="engineNo"
                    :class="RedBlod('engineNo')"
                    :label="'发动机号' + columnSeparator"
                  >
                    <el-input
                      v-model="carLicenseInfo.engineNo"
                      v-uppercase="true"
                      placeholder="请输入"
                      maxlength="20"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    prop="seats"
                    :class="RedBlod('seats')"
                    :label="'核定载客人数' + columnSeparator"
                  >
                    <el-input
                      v-number:integer="2"
                      v-model="carLicenseInfo.seats"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    prop="plateNo"
                    :class="RedBlod('plateNo')"
                    :label="'车牌号' + columnSeparator"
                  >
                    <el-input
                      v-model="carLicenseInfo.plateNo"
                      v-uppercase="true"
                      placeholder="请输入"
                      maxlength="8"
                      :disabled="isEdit && !updateCarFlag"
                      clearable
                      @blur="(e) => generateCity(e.target.value)"
                    />
                  </el-form-item>
                  <el-form-item
                    prop="originalPlateNo"
                    :label="'原车牌' + columnSeparator"
                  >
                    <el-input
                      v-model="carLicenseInfo.originalPlateNo"
                      v-uppercase="true"
                      placeholder="请输入"
                      maxlength="16"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    prop="type"
                    :label="'车辆类型' + columnSeparator"
                  >
                    <el-select
                      v-model="carLicenseInfo.type"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in carTypeList"
                        :label="item.label"
                        :value="item.value"
                        :key="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    prop="property"
                    :label="'车辆属性' + columnSeparator"
                  >
                    <el-select
                      v-model="carLicenseInfo.property"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in attrubuteList"
                        :label="item.label"
                        :value="item.value"
                        :key="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    prop="registPlace"
                    :class="RedBlod('registPlace')"
                    :label="'车辆注册地' + columnSeparator"
                  >
                    <el-select
                      v-model="carInfo.registPlace"
                      filterable
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in cityList"
                        :label="item.city"
                        :value="item.adcode"
                        :key="item.adcode"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    :label="'所有人' + columnSeparator"
                    prop="owner"
                  >
                    <el-input
                      v-deleteEmoji
                      v-model="carLicenseInfo.owner"
                      placeholder="请输入"
                      maxlength="64"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="'住址' + columnSeparator"
                    prop="ownerAddress"
                  >
                    <el-input
                      v-deleteEmoji
                      v-model="carLicenseInfo.ownerAddress"
                      placeholder="请输入"
                      maxlength="128"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    prop="registDate"
                    :class="RedBlod('registDate')"
                    :label="'注册日期' + columnSeparator"
                  >
                    <el-date-picker
                      v-model="carLicenseInfo.registDate"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="选择日期"
                      :picker-options="carInfoRegistDate"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item
                    prop="usage"
                    :label="'使用性质' + columnSeparator"
                  >
                    <el-select
                      v-model="carLicenseInfo.usage"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in useList"
                        :label="item.label"
                        :value="item.value"
                        :key="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    prop="usageDate"
                    :label="'车辆性质变更时间' + columnSeparator"
                  >
                    <el-date-picker
                      v-model="carLicenseInfo.usageDate"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="选择日期"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item
                    prop="issueOrgan"
                    :label="'发证机关' + columnSeparator"
                  >
                    <el-input
                      v-model="carLicenseInfo.issueOrgan"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    prop="issueDate"
                    :label="'行驶证发证日期' + columnSeparator"
                  >
                    <el-date-picker
                      v-model="carLicenseInfo.issueDate"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="选择日期"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item
                    prop="inspectDate"
                    :class="RedBlod('inspectDate')"
                    :label="'年检有效期' + columnSeparator"
                  >
                    <el-date-picker
                      v-model="carLicenseInfo.inspectDate"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="年检有效期"
                      :picker-options="carInfoInspectDate"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item
                    prop="scrapDate"
                    :label="'强制报废日期' + columnSeparator"
                  >
                    <el-date-picker
                      v-model="carLicenseInfo.scrapDate"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="强制报废日期"
                      :picker-options="carInfoScrapDate"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item
                    prop="drivingLicenseNo"
                    :label="'档案编号' + columnSeparator"
                  >
                    <el-input
                      v-model="carLicenseInfo.drivingLicenseNo"
                      v-uppercase="true"
                      placeholder="请输入"
                      maxlength="17"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    prop="totalMass"
                    :label="'总质量' + columnSeparator"
                  >
                    <el-input
                      v-model="carLicenseInfo.totalMass"
                      v-uppercase="true"
                      placeholder="请输入质量（含单位）"
                      maxlength="16"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    prop="kerbWeight"
                    :label="'整备质量' + columnSeparator"
                  >
                    <el-input
                      v-model="carLicenseInfo.kerbWeight"
                      v-uppercase="true"
                      placeholder="请输入质量（含单位）"
                      maxlength="16"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    prop="approvedLoad"
                    :label="'核定载质量' + columnSeparator"
                  >
                    <el-input
                      v-model="carLicenseInfo.approvedLoad"
                      v-uppercase="true"
                      placeholder="请输入质量（含单位）"
                      maxlength="16"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    prop="overallSize"
                    :label="'外廓尺寸' + columnSeparator"
                  >
                    <el-input
                      v-model="carLicenseInfo.overallSize"
                      placeholder="请输入尺寸（含单位）"
                      maxlength="17"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    prop="tractionMass"
                    :label="'准牵引总质量' + columnSeparator"
                  >
                    <el-input
                      v-model="carLicenseInfo.tractionMass"
                      v-uppercase="true"
                      placeholder="请输入质量（含单位）"
                      maxlength="16"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="'行驶证备注' + columnSeparator"
                    prop="licenseRemarks"
                  >
                    <el-input
                      v-model="carLicenseInfo.licenseRemarks"
                      type="textarea"
                      maxlength="200"
                      show-word-limit
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="'检验记录' + columnSeparator"
                    prop="record"
                  >
                    <el-input
                      disabled
                      v-model="carLicenseInfo.record"
                      type="textarea"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </template>
              </column-box>
            </el-form>
          </div>
        </el-collapse-item>
        <el-collapse-item
          title="行驶证领取信息"
          name="driver_license_collection"
        >
          <div>
            <el-form ref="driverLicenseCollection">
              <column-box label-width="120px">
                <el-form-item
                  prop="receiveDate"
                  :label="'领取日期' + columnSeparator"
                >
                  <el-date-picker
                    v-model="carLicenseInfo.receiveDate"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item
                  prop="receivePlace"
                  :label="'领取地点' + columnSeparator"
                >
                  <el-input
                    v-model="carLicenseInfo.receivePlace"
                    v-uppercase="true"
                    placeholder="请输入领取地点"
                    clearable
                    maxlength="50"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  prop="licenseReceiver"
                  :label="'签收人' + columnSeparator"
                >
                  <el-input
                    v-model="carLicenseInfo.licenseReceiver"
                    v-uppercase="true"
                    placeholder="请输入签收人"
                    clearable
                    maxlength="15"
                  ></el-input>
                </el-form-item>
              </column-box>
            </el-form>
          </div>
        </el-collapse-item>
        <el-collapse-item title="车辆标签" name="car_tag">
          <template slot="title">
            <span>车辆标签&nbsp;&nbsp;</span>
            <el-tooltip
              class="item"
              effect="dark"
              content="勾选了不可租标签后，非租赁车辆将不可待租。如需增加标签可提交问题反馈工单提交申请。"
              placement="right"
            >
              <i class="QS-icon-question-outline"></i>
            </el-tooltip>
          </template>
          <SelectTag
            labelName="不可租标签"
            v-model="nonRentableTagList"
            :allTagList="allNonRentableTagList"
            :currentTagList="checkedNonRentTableTagList"
          />
          <SelectTag
            labelName="普通标签"
            v-model="tagList"
            :allTagList="allTagList"
            :currentTagList="checkedTagList"
          />
        </el-collapse-item>

        <el-collapse-item title="车辆照片" name="car_photo">
          <div class="zitem-wrapper">
            <div class="zitem-box">
              <div class="zitem">
                <div class="label">
                  <div class="tar">
                    <el-popover
                      placement="top-start"
                      title="温馨提示"
                      width="220"
                      trigger="hover"
                      :content="uploadCommonTip"
                    >
                      <i
                        slot="reference"
                        class="el-icon-question"
                        style="
                          color: #c8c9cc;
                          font-size: 16px;
                          padding-right: 3px;
                        "
                      /> </el-popover
                    >{{ `图片上传${columnSeparator}` }}
                  </div>
                </div>
                <div class="content w590">
                  <UploadCommon
                    v-for="(item, index) in aloneFileUpload"
                    :key="index"
                    :ref="item.key"
                    :class="{
                      ml16: index !== 0 && index !== 5,
                      mt16: index >= 5
                    }"
                    :fileList="item.data"
                    :fileTitle="item.txt"
                    :sizeType="4"
                    commonUpload
                    group="order"
                    code="order_vehicle_pic"
                  ></UploadCommon>
                </div>
              </div>
            </div>
            <div class="zitem-box mt16">
              <div class="zitem">
                <div class="label">
                  <div class="tar">
                    <el-popover
                      placement="top-start"
                      title="温馨提示"
                      width="220"
                      trigger="hover"
                      :content="uploadCommonTip"
                    >
                      <i
                        slot="reference"
                        class="el-icon-question"
                        style="
                          color: #c8c9cc;
                          font-size: 16px;
                          padding-right: 3px;
                        "
                      /> </el-popover
                    >{{ `自定义照片${columnSeparator}` }}
                  </div>
                </div>
                <div class="content w520">
                  <UploadCommon
                    ref="customImgRef"
                    :fileList="customImg"
                    :isAlone="false"
                    :isShowCustom="true"
                    :limit="10"
                    fileTitle="自定义"
                    :sizeType="4"
                    commonUpload
                    group="order"
                    code="order_vehicle_pic"
                  ></UploadCommon>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item title="车辆备注" name="car_remark">
          <div class="car_remarks">
            <el-form ref="carRemarks">
              <column-box label-width="120px">
                <el-form-item prop="remarks" :label="'备注' + columnSeparator">
                  <el-input
                    v-model="carInfo.remarks"
                    type="textarea"
                    maxlength="200"
                    show-word-limit
                    placeholder="请输入车辆备注"
                  ></el-input>
                </el-form-item>
                <div class="remark_content">
                  <UploadCommon
                    ref="remarkImgRef"
                    :fileList="remark_imgs"
                    :isAlone="false"
                    :isShowCustom="true"
                    :limit="1"
                    fileTitle="自定义"
                    :sizeType="4"
                    commonUpload
                    group="order"
                    code="order_vehicle_note_pic"
                  ></UploadCommon>
                </div>
              </column-box>
            </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
      <template slot="bottomAction">
        <div class="sumbit-btns" v-if="carId">
          <el-button @click="confirmBack()" size="mini">退出编辑</el-button>
          <el-button
            :loading="oLoading.submit"
            type="primary"
            size="mini"
            v-if="carMessage === 1 || carMessage === 2 || carMessage === 4"
            @click="addHandle(2)"
            >提交保存</el-button
          >
        </div>
        <div class="sumbit-btns" v-else>
          <el-button @click="confirmBack()" size="mini">取消创建</el-button>
          <el-button
            :loading="oLoading.submit"
            type="primary"
            size="mini"
            @click="addHandle(1)"
            >确认创建</el-button
          >
        </div>
      </template>
    </QS-scroller-box>
    <dialogWrap v-model="backTip" title="提示" :width="'424px'">
      <p>退出编辑不会保存本次修改，确定退出么？</p>
      <template slot="footer">
        <el-button size="small" @click="backTip = false">返回修改</el-button>
        <el-button type="primary" size="small" @click="goPageBack(false)">
          确认退出
        </el-button>
      </template>
    </dialogWrap>
    <!-- 新增服务商 -->
    <HandleProvider
      ref="HandleProvider"
      type="add"
      :serviceTypeProp="serviceType"
      @handleSuccess="handleSuccess"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import CARDICT from '@/store/dict/carDict.js'
// eslint-disable-next-line import/no-cycle
import {
  getCarDetails,
  getCityList,
  getDrivingInfo,
  addCar,
  editCar,
  getCarStandardDataList,
  getCarProviderPropertyList, // 获取车源方、产权方下拉框
} from '@/api/domain/cars'
import { getAllEmployeeList } from '@/api/carManage/index.js'
import { getNonRentableList } from '@/api/domain/organize'
import { isEmojiCharacter } from '@/utils/validate'
import { validateCarVin, validateTipMsg } from '@/utils/extendFormVaildate.js'
import SelectTag from '@/components/SelectTag/index.vue'
import _cloneDeep from 'lodash/cloneDeep'
import HandleProvider from '../components/handleProvider.vue'
import WindowCommunication from '@/utils/windowCommunication'

// 校验表显里程
const validateDisplayMile = (_, val, callback) => {
  if (val > 999999) {
    callback(new Error('表显里程 已超出最大输入范围999999'))
  } else {
    callback()
  }
}
export default {
  name: 'operationCar',
  components: {
    SelectTag,
    HandleProvider,
  },
  provide() {
    return {
      serviceType: this.serviceType,
    }
  },
  data() {
    return {
      carId: '', // 车辆id
      pageTitle: '', // 页面标题
      allTagList: [], // 所有普通标签列表
      tagList: [], // 选中的普通标签列表（用户选中，传给服务用）
      checkedTagList: [], // 已经选中的普通标签列表（详情查询出来的）
      allNonRentableTagList: [], // 所有不可租标签
      nonRentableTagList: [], // 选中的不可租标签列表（用户选中，传给服务用）
      checkedNonRentTableTagList: [], // 已经选中的不可租标签列表（详情查询出来的）
      oLoading: {
        detail: false,
        submit: false,
      },
      // 驾驶证
      drivingImg: {
        main: [],
        back: [],
        viceBack: [],
      },
      // 自定义图片
      customImg: [],
      // 车源方
      carProviderList: [],
      // 产权方
      propertyList: [],
      // 车管
      carTubeList: [],
      // 注册地
      cityList: [],
      carMessage: '',
      // 因为表单需要多个对象的属性组合，所以先拼接一个
      carInfoPage: {
        modelId: '', // 车型ID
        managerId: '', // 车管ID
        purchaseType: '', // 采购方式
        vin: '', // 车架号VUN码
        plateNo: '', // 车牌号
        engineNo: '', // 发动机号
        registDate: '', // 注册日期
        inspectDate: '', // 年检有效期
        scrapDate: '', // 强制报废日期
        usage: '', // 使用性质  1营运 2非营运
        property: '', // 车辆属性   1个人  2公司
        type: '', // 车辆类型  1大型汽车/2小型汽车/3专用汽车/4特种车/5无轨电车/6有轨电车/7电瓶车/8三轮摩托车/9两轮摩托车/100其他
        color: '', // 车辆颜色
        registPlace: '', // 车辆注册地
        seats: '', // 核定载客人数
        issueOrgan: '', // 行驶证发证机关
        providerId: '', // 车源方
        carRemarks: '', // 备注
        propertyId: '', // 车源方
        storagePlace: '', // 存放地
        displayMile: '', // 表显里程
      },
      carColor: [
        // 车型ID
        { key: 1, state: 1, parentKey: 'carInfo', props: 'deptId' },
        { key: 1, state: 1, parentKey: 'carInfo', props: 'modelId' },
        { key: 2, state: 1, parentKey: 'carInfo', props: 'vin' },
        { key: 3, state: '', parentKey: 'carLicenseInfo', props: 'plateNo' },
        { key: 4, state: '', parentKey: 'carLicenseInfo', props: 'engineNo' },
        // 行驶证正面
        { key: 5, state: '', parentKey: 'drivingImg', props: 'main' },
        // 行驶证反
        { key: 6, state: '', parentKey: 'drivingImg', props: 'back' },
        // 注册日期
        { key: 7, state: '', parentKey: 'carInfo', props: 'registDate' },
        {
          key: 8,
          state: '',
          parentKey: 'carLicenseInfo',
          props: 'inspectDate',
        },
        { key: 12, state: '', parentKey: 'carInfo', props: 'storagePlace' },
        { key: 13, state: '', parentKey: 'carInfo', props: 'color' },
        { key: 14, state: '', parentKey: 'carLicenseInfo', props: 'seats' },
        { key: 20, state: '', parentKey: 'carInfo', props: 'displayMile' },
      ],
      updateCarFlag: false, // 是否更新车辆信息,0:不更新,1:更新
      carInfo: {
        carState: '', // 车辆状态
        deptId: '', // 所属部门
        vin: '', // 车架号VUN码
        modelId: '', // 车型ID
        managerId: '', // 车管ID
        purchaseType: '', // 采购方式
        color: '', // 车辆颜色
        providerId: '', // 车源方
        photo: '', // 车辆照片
        customPhoto: '', // 自定义照片
        propertyId: '', // 产权方
        storagePlace: '', // 存放地
        registPlace: '', // 车辆注册地
        registDate: '', // 注册日期
        appearanceState: '', // 车辆外观状态
        chassisState: '', // 车辆底盘状态
        displayMile: '', // 表显里程
        carRemarks: '', // 备注
        remarks: '',
        mortgagor: '', // 车辆抵押方
        adcode: '', // 运营城市
        brandId: '', // 品牌ID
        seriesId: '', // 车系ID
      },
      // 行驶证
      carLicenseInfo: {
        vin: '', // 车架号VUN码
        plateNo: '', // 车牌号
        originalPlateNo: '', // 原车牌
        type: 2, // 车辆类型  1大型汽车/2小型汽车/3专用汽车/4特种车/5无轨电车/6有轨电车/7电瓶车/8三轮摩托车/9两轮摩托车/100其他
        property: '', // 车辆属性   1个人  2公司
        usage: '', // 使用性质  1营运 2非营运
        usageDate: '', // 车辆性质变更时间
        issueOrgan: '', // 行驶证发证机关
        engineNo: '', // 发动机号
        issueDate: '', // 行驶证发证日期
        seats: '', // 核定载客人数
        inspectDate: '', // 年检有效期
        scrapDate: '', // 强制报废日期
        receiveDate: '', // 行驶证领取记录-领取日期
        receivePlace: '', // 行驶证领取记录-领取地点
        licenseReceiver: '', // 行驶证领取人
        drivingLicenseNo: '', // 行驶证档案号
        totalMass: '', // 总质量
        kerbWeight: '', // 整备质量
        approvedLoad: '', // 核定载质量
        overallSize: '', // 外廓尺寸
        tractionMass: '', // 准牵引总质量
        photo: '', // 行驶证照片
        licenseRemarks: '', // 行驶证备注
        registDate: '', // 注册日期
        owner: '', // 所有人
        ownerAddress: '', // 住址
        record: '', // ocr扫描出的检验记录
        adcode: '', // 运营城市
      },
      // 网约车证
      carTransportLicense: {
        registDate: '', // 登记日期
        effectDate: '', // 有效期开始日期
        transportLicenseNo: '', // 交运管许可字号
        bizScope: '', // 经营范围
        issueOrgan: '', // 网约车发证机关
        photo: '', // 网约车证照片
      },
      // 登记证
      carRegistCertInfo: {
        registNo: '', // 登记编号
        productionDate: '', // 出厂日期
        issueDate: '', // 发证日期
        acquisitionMode: '', // 车辆获得方式
        registOrgan: '', // 发证机关
        photo: '', // 登记证照片
      },
      // 车辆照片
      aloneFileUpload: [
        {
          key: 'load1',
          txt: '左前45°',
          data: [],
        },
        {
          key: 'load2',
          txt: '右后45°',
          data: [],
        },
        {
          key: 'load3',
          txt: '发动机舱',
          data: [],
        },
        {
          key: 'load4',
          txt: '车顶',
          data: [],
        },
        {
          key: 'load5',
          txt: '前排座椅',
          data: [],
        },
        {
          key: 'load6',
          txt: '后排座椅',
          data: [],
        },
        {
          key: 'load7',
          txt: '中控台',
          data: [],
        },
        {
          key: 'load8',
          txt: '车内顶棚',
          data: [],
        },
        {
          key: 'load9',
          txt: '车钥匙',
          data: [],
        },
        {
          key: 'load10',
          txt: '后备箱',
          data: [],
        },
      ],
      // 备注图片
      remark_imgs: [],
      carLicenseRules: {
        owner: [
          {
            validator: (rule, val, callback) => {
              if (isEmojiCharacter(val)) {
                return callback(new Error('不支持表情'))
              }
              callback()
            },
            trigger: ['change', 'blur'],
          },
        ],
        ownerAddress: [
          {
            validator: (rule, val, callback) => {
              if (isEmojiCharacter(val)) {
                return callback(new Error('不支持表情'))
              }
              callback()
            },
            trigger: ['change', 'blur'],
          },
        ],
      },
      carInfoRules: {
        deptId: [
          {
            required: true,
            message: '所属部门不能为空',
          },
        ],
        vin: [
          {
            required: true,
            message: '车辆VIN码不能为空',
            trigger: 'blur',
          },
          {
            validator: validateCarVin,
            trigger: 'change',
          },
        ],
        brandId: [
          {
            required: true,
            message: '请选择品牌车系',
            trigger: ['change', 'blur'],
          },
        ],
        modelId: [
          {
            required: true,
            message: '车型不能为空',
            trigger: ['change', 'blur'],
          },
        ],
        displayMile: [
          {
            validator: validateDisplayMile,
            trigger: ['change', 'blur'],
          },
        ],
        mortgagor: [
          {
            validator: (rule, val, callback) => {
              if (val === null) return callback()
              if (isEmojiCharacter(val)) {
                return callback(new Error('不支持表情'))
              }
              if (val.length > 50) {
                return callback(new Error('最大长度为50'))
              }
              callback()
            },
            trigger: ['change', 'blur'],
          },
        ],
      },
      // 当前展开面板
      activeNames: [
        'car_base_info',
        'driver_license_info',
        'driver_license_collection',
        'car_tag',
        'car_condtion',
        'car_photo',
        'car_remark',
      ],
      action: 'add',
      // 加粗标红项配置（确认到库）
      requiredEum: {
        confirmCarInStore: [
          'storagePlace',
          'engineNo',
          'color',
          'seats',
          'plateNo',
        ],
      },
      backTip: false,
      serviceType: '', // 服务商类型 0-车源方 3-产权方
      originPlateNo: null, // 原车牌号
      brandSeriesModel: {},
    }
  },
  watch: {
    'carLicenseInfo.registDate': {
      handler(val) {
        if (val) {
          this.carInfo.registDate = val
        }
      },
    },
    brandSeriesModel: {
      handler(val) {
        const { brandId, seriesId, modelId } = val
        this.carInfo.modelId = modelId
        this.carInfo.brandId = brandId
        this.carInfo.seriesId = seriesId
        this.$nextTick(() => {
          this.$refs.carInfoRef.clearValidate('brandId')
          this.$refs.carInfoRef.clearValidate('modelId')
        })
      },
      deep: true,
    },
  },
  created() {
    const { id } = this.$route.query
    if (!id) {
      this.carInfo.deptId = this.userInfo.rootDeptId
    }
    // 注册地
    this.getCityList()
    this.init()
  },
  activated() {
    document.querySelector('#app-main').scrollTo({ top: 0, behavior: 'smooth' })
    const isKeepAlive = location.href.indexOf('keepAlive=1') > 0
    if (!isKeepAlive) {
      this.tagList = []
      this.allTagList = []
      this.nonRentableTagList = []
      this.allNonRentableTagList = []
      this.checkedTagList = []
      this.checkedNonRentTableTagList = []
      this.init()
    }
  },
  deactivated() {
    delete this.carInfo.basicItemState
  },
  methods: {
    // 校验车身颜色
    checkColor(tag, rule, value, callback) {
      if (!value && tag !== 'init') {
        callback(new Error('颜色不能为空'))
      } else {
        callback()
      }
    },
    init() {
      const {
        carColor,
        requiredEum: { confirmCarInStore },
      } = this
      const { action } = this.$route.query
      // 确认到库操作
      if (action && action === 'confirmCarInStore') {
        this.action = action
        // 确认到库需更改部分字段的加粗标红
        for (const item of carColor) {
          confirmCarInStore.includes(item.props) && (item.state = 1)
        }
        this.$set(this.carInfoRules, 'color', [
          {
            required: true,
            message: '颜色不能为空',
            trigger: ['blur', 'change'],
          },
          {
            validator: (rule, value, callback) => {
              this.checkColor('init', rule, value, callback)
            },
          },
        ])
        this.$set(this.carInfoRules, 'storagePlace', [
          {
            required: true,
            message: '存放地不能为空',
            trigger: ['blur', 'change'],
          },
        ])
        this.$set(this.carLicenseRules, 'seats', [
          {
            required: true,
            message: '核定载客人数不能为空',
            trigger: ['blur', 'change'],
          },
        ])
        this.$set(this.carLicenseRules, 'engineNo', [
          {
            required: true,
            message: '发动机号不能为空',
            trigger: ['blur', 'change'],
          },
        ])
      } else {
        this.action = 'add'
        // 确认到库需去掉部分字段的加粗标红
        for (const item of carColor) {
          confirmCarInStore.includes(item.props) && (item.state = '')
        }
        this.$set(this.carInfoRules, 'storagePlace', [])
        this.$set(this.carInfoRules, 'color', [])
        this.$set(this.carLicenseRules, 'seats', [])
        this.$set(this.carLicenseRules, 'engineNo', [])
      }
      this.$nextTick(() => {
        [
          'carInfoRef',
          'carLicenseInfoRef',
          'driverLicenseCollection',
          'carRemarks',
        ].forEach((ref) => {
          this.$refs[ref].clearValidate()
        })
      })
      const { id } = this.$route.query
      if (id) {
        this.carId = parseInt(id)
        // 获取车辆详情
        this.handleGetCarDetails()
        this.pageTitle =
          action && action === 'confirmCarInStore' ? '确认到库' : '编辑车辆'
      } else {
        this.pageTitle = '新建车辆'
      }
      // 获取车辆标签
      this.handleGetNonRentableTagList()
      // 获取待租标准
      this.getRentStandard()
      // 车源方
      this.getCarProviderPropertyList(0)
      // 产权方
      this.getCarProviderPropertyList(3)
      // 车管
      this.getCarTubeList()
    },
    // 获取车辆标签
    async handleGetNonRentableTagList() {
      const { code, data } = await getNonRentableList({
        type: 1,
      })
      if (code !== 1) return
      this.allTagList = data.tagList || []

      // 非待租状态下，不展示『已备车』标签
      if (this.carInfo.carState !== 20) {
        const nl = this.allTagList.filter((item) => item.name !== '已备车')
        this.$set(this, 'allTagList', nl)
      }

      this.allNonRentableTagList = data.nonRentableTagList || []
    },
    /**
     * 获取待租标准
     */
    async getRentStandard() {
      const { carColor } = this
      const { code, data } = await getCarStandardDataList({
        state: 1,
      })
      if (code !== 1) return
      const allFieldCol = [...data.carAndLicenseList, ...data.carMatterList]
      // 根据待租标准配置加粗标红字段
      allFieldCol.forEach((rent) => {
        const field = carColor.find(
          (v) => Number(v.key) === Number(rent.itemType),
        )
        field && (field.state = Number(rent.state))
      })
      // 【编辑车辆】&【确认倒库】需要标红以下固定字段且改为必填项
      if (this.pageTitle === '编辑车辆' || this.pageTitle === '确认到库') {
        for (const item of carColor) {
          // 车辆颜色，能源类型，核定载客人数，注册日期，在编辑态和确认到库变成必填项目
          if (
            ['color', 'seats', 'registDate'].includes(item.props)
          ) {
            item.state = 1
          }
        }
        this.$set(this.carInfoRules, 'color', [
          {
            required: true,
            message: '请选择车身颜色',
            trigger: ['blur', 'change'],
          },
          {
            validator: (rule, value, callback) => {
              this.checkColor('init', rule, value, callback)
            },
          },
        ])
        this.$set(this.carLicenseRules, 'seats', [
          {
            required: true,
            message: '核定载客人数不能为空',
            trigger: ['blur', 'change'],
          },
        ])
        this.$set(this.carLicenseRules, 'registDate', [
          {
            required: true,
            message: '请选择注册日期',
            trigger: ['blur', 'change'],
          },
        ])
      }
    },
    // 获取车辆注册地
    async getCityList() {
      const { code, data } = await getCityList()
      if (code === 1) {
        this.cityList = data
      }
    },
    // 获取车管列表
    async getCarTubeList() {
      const { code, data } = await getAllEmployeeList()
      if (code === 1) {
        this.carTubeList = data
      }
    },
    // 获取车辆详情
    async handleGetCarDetails() {
      this.oLoading.detail = true
      const { code, data } = await getCarDetails({
        id: this.carId,
      })
      this.oLoading.detail = false
      if (code !== 1) return
      this.updateCarFlag = !!data?.updateCarFlag
      // 车辆基本信息
      if (data.carInfo) {
        Object.keys(data.carInfo).forEach((item) => {
          Object.keys(this.carInfo).forEach((carInfoItem) => {
            if (item === carInfoItem) {
              // 车辆信息赋值
              this.carInfo[carInfoItem] = data.carInfo[carInfoItem]
            }
          })
        })
        // 车辆外观状态及车辆底盘状态置默认值
        this.carInfo.appearanceState = data?.carInfo?.appearanceState || 1
        this.carInfo.chassisState = data?.carInfo?.chassisState || 1

        // 同步车辆vin码
        this.carInfo.vin = data.carLicenseInfo.vin

        // 车辆基本状态信息
        this.carInfo.basicItemState = Number(data.carInfo.basicItemState)
        this.carMessage = Number(data?.carInfo?.basicItemState)

        // 解析车辆备注
        if (data?.carInfo?.carRemarks && data?.carInfo?.carRemarks.length > 0) {
          const [remarkItem] = data.carInfo.carRemarks
          this.carInfo.carRemarks = remarkItem.remarks
          this.$set(this.carInfo, 'remarks', remarkItem.remarks)
          // 车辆备注图片解析
          this.remark_imgs = remarkItem.photo
            ? this.getEchoUploadFileData(remarkItem.photo, true)
            : []
        }
        this.carLicenseInfo.registDate = data.carInfo?.registDate
        this.brandSeriesModel = {
          brandId: data.carInfo.brandId,
          seriesId: data.carInfo.seriesId,
          modelId: data.carInfo.modelId,
        }
      }


      // 车辆行驶证信息
      if (data.carLicenseInfo) {
        Object.keys(data.carLicenseInfo).forEach((item) => {
          Object.keys(this.carLicenseInfo).forEach((carLicenseItem) => {
            if (item === carLicenseItem) {
              // 行驶证信息赋值
              this.carLicenseInfo[carLicenseItem] =
                data.carLicenseInfo[carLicenseItem]
            }
          })
        })
      }
      // 行驶证照片（主页）
      this.drivingImg.main = this.getEchoUploadFileData(
        data?.carLicenseInfo?.drivingLicense,
        true,
      )
      // 行驶证照片（副页）
      this.drivingImg.back = this.getEchoUploadFileData(
        data?.carLicenseInfo?.drivingSubLicense,
        true,
      )
      // 行驶证副页背面
      this.drivingImg.viceBack = this.getEchoUploadFileData(
        data.carLicenseInfo.subLicenseBackPhoto,
        true,
      )

      // 车辆普通标签
      if (data.tagList && data.tagList.length) {
        this.checkedTagList = data.tagList
      }

      // 车辆不可租标签
      if (data.nonRentableTagList && data.nonRentableTagList.length) {
        this.checkedNonRentTableTagList = data.nonRentableTagList
      }

      // 车辆照片
      const aloneArr = this.getEchoUploadFileData(data?.carInfo?.photo, true)
      aloneArr.forEach((item, index) => {
        if (Array.isArray(item)) {
          this.aloneFileUpload[index].data = item
        } else if (item?.url) {
          this.aloneFileUpload[index].data = [item]
        } else {
          this.aloneFileUpload[index].data = []
        }
      })

      // 车辆自定义照片
      this.customImg = this.getEchoUploadFileData(
        data?.carInfo?.customPhoto,
        true,
      )
      this.getCarProviderPropertyList(0, data?.carInfo?.providerId) // 车源方
      this.getCarProviderPropertyList(3, data?.carInfo?.propertyId) // 产权方

      // 运营城市
      this.carInfo.adcode = data.carLicenseInfo.adcode
      // 原车牌号，为比较用户是否修改了车牌号。如果用户改了车牌号则会自动更新运营城市，否则不更新
      this.originPlateNo = data.carLicenseInfo.plateNo
    },
    // 新增 / 编辑
    async addHandle(type) {
      let validResult = await Promise.all([
        new Promise((resolve) => {
          this.$refs.carInfoRef.validate((valid, ruleObj) => {
            if (!valid) {
              resolve(validateTipMsg(ruleObj))
            }
            resolve(null)
          })
        }),
        new Promise((resolve) => {
          this.$refs.carLicenseInfoRef.validate((valid, ruleObj) => {
            if (!valid) {
              resolve(validateTipMsg(ruleObj))
            }
            resolve(null)
          })
        }),
      ])
      validResult = validResult.flat(Infinity).filter((v) => v !== null)
      const len = validResult.length
      if (len === 0) {
        this.submitHandle(type)
        return
      }
      if (len > 0 && len <= 3) {
        const tipMsg = validResult.map((v) => v.replace('不能为空', ''))
        this.$message.error(`请填写必填项「${tipMsg.join('、')}」`)
      }
      len > 3 && this.$message.error('请填写必填项')
    },
    // 保存发送请求操作
    submitHandle(type) {
      this.getSubmitPhoto()
      const tempCarInfo = _cloneDeep(this.carInfo)
      delete tempCarInfo.remarks
      const { vin, adcode, deptId } = this.carInfo
      this.carLicenseInfo.vin = vin
      this.carLicenseInfo.adcode = adcode
      // 编辑
      if (type === 2 && this.carId) {
        this.carInfo.id = this.carId
        tempCarInfo.id = this.carId
        this.oLoading.submit = true
        editCar({
          deptId,
          carInfo: tempCarInfo,
          carLicenseInfo: this.carLicenseInfo,
          tagList: Array.from(
            new Set([...this.tagList, ...this.nonRentableTagList]),
          ),
        })
          .then(({ code }) => {
            this.oLoading.submit = false
            if (code === 1) {
              this.$message.success('操作成功')
              this.goCarList()
            }
          })
          .catch(() => {
            this.oLoading.submit = false
          })
      } else if (type === 1) {
        this.oLoading.submit = true
        // 新增
        addCar({
          deptId,
          carInfo: tempCarInfo, // 车辆基本信息
          carLicenseInfo: this.carLicenseInfo, // 行驶证信息
          tagList: Array.from(
            new Set([...this.tagList, ...this.nonRentableTagList]),
          ), // 车辆普通标签
        })
          .then(({ code, data }) => {
            this.oLoading.submit = false
            if (code === 1) {
              // 签约提车页面跨页面通信 刷新签约提车页面车辆列表
              this.sendMessage(data)
              this.$message.success('添加成功')
              this.goPageBack(true)
            }
          })
          .catch(() => {
            this.oLoading.submit = false
          })
      }
    },
    // 行驶证OCR识别事件
    drivingImgMainSuccess(url) {
      this.oLoading.detail = true
      getDrivingInfo({
        imageUrl: url,
        cardSide: 'FRONT',
      })
        .then(({ data }) => {
          this.oLoading.detail = false
          this.setCarLicenseInfo(data.frontInfo) // 处理数据
        })
        .catch(() => {
          this.oLoading.detail = false
        })
    },

    // 处理数据
    setCarLicenseInfo(data) {
      const {
        vin,
        plateNo,
        issueDate,
        engineNo,
        owner,
        address,
        vehicleType,
        useCharacter,
        registerDate,
        seal,
      } = data || {}
      if (
        this.isEdit &&
        this.carLicenseInfo.plateNo
        && (this.carLicenseInfo.plateNo !== plateNo
        || this.carInfo.vin !== vin)
      ) {
        this.$message.error('车牌号信息不符，请检查您的行驶本')
        return
      }
      // 发证日期
      this.carLicenseInfo.issueDate = issueDate
      // 车牌号
      this.carLicenseInfo.plateNo = plateNo
      if (plateNo) {
        this.generateCity(plateNo)
      }
      // vin码
      this.carInfo.vin = vin
      this.carLicenseInfo.vin = vin
      // 发动机号码
      this.carLicenseInfo.engineNo = engineNo
      this.carLicenseInfo.owner = owner
      this.carLicenseInfo.ownerAddress = address

      // 车辆类型
      this.carLicenseInfo.type = parseInt(vehicleType, 10) || ''
      // 使用性质
      if (useCharacter) {
        this.carLicenseInfo.usage = parseInt(useCharacter, 10)
      } else {
        this.carLicenseInfo.usage = ''
      }
      // 注册日期
      if (registerDate) {
        this.carInfo.registDate = moment(
          parseInt(registerDate, 10),
        ).format('yyyy-MM-DD')
        this.carLicenseInfo.registDate = moment(
          parseInt(registerDate, 10),
        ).format('yyyy-MM-DD')
      } else {
        this.carLicenseInfo.registDate = ''
        this.carInfo.registDate = ''
      }
      // 发证机关
      this.carLicenseInfo.issueOrgan = seal
    },
    // 驾驶证副页orc成功事件
    drivingImgBackSuccess(url) {
      this.oLoading.detail = true
      getDrivingInfo({
        imageUrl: url,
        cardSide: 'BACK',
      })
        .then(({ data }) => {
          this.oLoading.detail = false
          this.setDrivingBackData(data.backInfo)
        })
        .catch(() => {
          this.oLoading.detail = false
        })
    },
    // 设置ocr驾驶正反面信息
    setDrivingBackData(data) {
      const {
        plateNo,
        marks,
        seats,
        allowNum,
        totalMass,
        fileNo,
        totalQuasiMass,
        curbWeight,
        externalSize,
        loadQuality,
        record,
      } = data || {}
      if (this.isEdit && this.carLicenseInfo.plateNo !== plateNo) {
        return
      }
      this.carLicenseInfo.licenseRemarks = marks
      this.carLicenseInfo.seats = seats - 0 || allowNum - 0
      this.carLicenseInfo.plateNo = plateNo
      if (plateNo) {
        this.generateCity(plateNo)
      }

      // 总质量
      this.carLicenseInfo.totalMass = totalMass || ''

      this.carLicenseInfo.drivingLicenseNo = fileNo
      // tractionMass 准牵引总质量
      this.carLicenseInfo.tractionMass = totalQuasiMass || ''
      // 整备质量
      this.carLicenseInfo.kerbWeight = curbWeight || ''
      // 外廓尺寸
      this.carLicenseInfo.overallSize = externalSize || ''
      this.carLicenseInfo.approvedLoad = loadQuality || ''
      this.carLicenseInfo.record = record || ''

      // 截取有效期 record: '检验有效期至2016年09月辽K(车管)柴油'
      if (record) {
        const _date = record.replace(/[^0-9]/gi, '')
        const _year = _date.substr(0, 4)
        const _month = _date.substr(4, 2)
        const _day = moment(`${_year}-${_month}-01`)
          .endOf('month')
          .format('DD')
        const str = (_year && _month && `${_year}-${_month}-${_day}`) || ''
        this.carLicenseInfo.inspectDate = str
        this.carInfoPage.inspectDate = str
      }
    },
    // 获取页面上所有图片
    getSubmitPhoto() {
      // 行驶证主页
      this.carLicenseInfo.drivingLicense = this.getUoloadCommonFileData(
        this.drivingImg.main,
      )
      // 行驶证副页
      this.carLicenseInfo.drivingSubLicense = this.getUoloadCommonFileData(
        this.drivingImg.back,
      )
      // 副页背面
      this.carLicenseInfo.subLicenseBackPhoto = this.getUoloadCommonFileData(
        this.drivingImg.viceBack,
      )

      // 车辆照片
      const _uploadImg10 = []
      this.aloneFileUpload.forEach((item) => {
        if (item.data.length) {
          _uploadImg10.push(this.getUoloadCommonFileData(item.data, false)?.[0])
        } else {
          _uploadImg10.push('')
        }
      })
      if (_uploadImg10.length) {
        this.carInfo.photo = JSON.stringify(_uploadImg10)
      }

      // 自定义照片
      this.carInfo.customPhoto = this.getUoloadCommonFileData(this.customImg)

      // 车辆备注照片
      const { remarks } = this.carInfo
      this.carInfo.carRemarks = [
        {
          remarks,
          photo: this.getUoloadCommonFileData(this.remark_imgs),
        },
      ]
    },
    // 验证是否有编辑内容
    confirmBack() {
      const {
        carInfo,
        carLicenseInfo,
        tagList,
        nonRentableTagList,
        drivingImg: { main, back },
        aloneFileUpload,
        customImg,
        remark_imgs,
      } = this
      let hasValue = false
      // 车辆基本信息
      for (const car_info_key in carInfo) {
        if (carInfo[car_info_key]) {
          hasValue = true
          break
        }
      }
      // 行驶证信息
      for (const car_license_key in carLicenseInfo) {
        if (carLicenseInfo[car_license_key]) {
          hasValue = true
          break
        }
      }
      // 普通标签
      tagList.length > 0 && (hasValue = true)

      // 不可租标签
      nonRentableTagList.length > 0 && (hasValue = true)

      // 行驶证图片
      if (main.length > 0 || back.length > 0) {
        hasValue = true
      }
      // 车辆图片
      for (const carImg of aloneFileUpload) {
        const len = carImg.data.length
        if (len > 0) {
          hasValue = true
          break
        }
      }
      // 自定义图片
      customImg.length > 0 && (hasValue = true)
      // 车辆备注图片
      remark_imgs.length > 0 && (hasValue = true)

      hasValue ? (this.backTip = true) : this.goPageBack(false)
    },
    // 点击跳到车辆列表
    goCarList() {
      // 拦截逻辑,isBack:true 返回上一级
      if (this.$route.query.isBack) {
        this.goPageBack(true)
        return
      }
      this.$refreshBack(true) // 关闭当前tab
    },
    // 返回上一级页面
    goPageBack(status) {
      this.backTip = false
      this.$refreshBack(status) // 关闭当前ta
    },
    // 新增服务商
    handleSuccess() {
      if (this.serviceType === '0') {
        this.getCarProviderPropertyList(0, this.carInfo.providerId) // 车源方
      } else if (this.serviceType === '3') {
        this.getCarProviderPropertyList(3, this.carInfo.propertyId) // 产权方
      }
    },
    // 新增服务商弹窗显示
    handleProviderShow(type) {
      this.serviceType = type
      this.$refs.HandleProvider.handelDialogVisible = true
    },
    // 获取车源方产权方
    async getCarProviderPropertyList(type, id) {
      /**
       * type: 0-车源方；3-产权方
       * * */
      const { code, data } = await getCarProviderPropertyList({
        state: 1, // 启用
        serviceType: type,
        includeId: id || '',
      })
      if (code !== 1) return
      if (Number(type) === 0) this.carProviderList = data
      if (Number(type) === 3) this.propertyList = data
    },
    // 车牌号回显运营城市
    generateCity(plateNo) {
      // 如果车牌号没有变化，则不更新运营城市
      if (plateNo === this.originPlateNo) return
      this.originPlateNo = plateNo
      if (plateNo.length >= 2) {
        getCityList({ plateNo }).then((res) => {
          const { code, data } = res
          if (code === 1 && data) {
            this.carInfo.adcode = data[0]?.adcode
          }
        })
      }
    },
    sendMessage(data) {
      // todo 联调时车辆id换成真实值
      if (this.$route.query.scene) {
        const communication = new WindowCommunication('person_sign_contract')
        communication.send({
          type: 'add_car',
          data, // 车辆id
        })
        // 关闭window
        window.close()
      }
    },
  },
  computed: {
    ...mapGetters(['userInfo']),
    isEdit() {
      return !!this.$route.query?.id
    },
    // 部门是否已经选择
    isHaveDepartment() {
      return !this.carInfo.deptId
    },
    // 时间范围 默认前后十年
    timeLimit() {
      const _date = new Date()
      const tenYearsAgo = `${_date.getFullYear() - 10}-${_date.getMonth() +
        1}-${_date.getDate()}`
      const tenYearsAfter = `${_date.getFullYear() -
        0 +
        10}-${_date.getMonth() + 1}-${_date.getDate()}`
      return {
        ago: new Date(tenYearsAgo).getTime(),
        after: new Date(tenYearsAfter).getTime(),
      }
    },
    // 车辆信息-注册日期
    carInfoRegistDate() {
      return {
        disabledDate: (time) => {
          const { inspectDate } = this.carLicenseInfo // 年检有效期
          const { scrapDate } = this.carLicenseInfo // 强制报废
          time = time.getTime()
          if (inspectDate && scrapDate) {
            return (
              time < this.timeLimit.ago ||
              time > this.timeLimit.after ||
              time > new Date(inspectDate).getTime() ||
              time > new Date(scrapDate).getTime()
            )
          }

          if (inspectDate) {
            return (
              time < this.timeLimit.ago ||
              time > this.timeLimit.after ||
              time > new Date(inspectDate).getTime()
            )
          }

          if (scrapDate) {
            return (
              time < this.timeLimit.ago ||
              time > this.timeLimit.after ||
              time > new Date(scrapDate).getTime()
            )
          }

          return time < this.timeLimit.ago || time > this.timeLimit.after
        },
      }
    },
    // 车辆信息-年检有限期
    carInfoInspectDate() {
      return {
        disabledDate: (time) => {
          time = time.getTime()
          const { registDate } = this.carInfo // 注册日期
          if (registDate) {
            return (
              time < this.timeLimit.ago ||
              time > this.timeLimit.after ||
              time < new Date(registDate).getTime()
            )
          }
          return time < this.timeLimit.ago || time > this.timeLimit.after
        },
      }
    },
    // 车辆信息-强制报废日期
    carInfoScrapDate() {
      return {
        disabledDate: (time) => {
          time = time.getTime()
          const { registDate } = this.carInfo // 注册日期
          if (registDate) {
            return (
              time < this.timeLimit.ago ||
              time > this.timeLimit.after ||
              time < new Date(registDate).getTime()
            )
          }

          return time < this.timeLimit.ago || time > this.timeLimit.after
        },
      }
    },
    // 车辆类型
    carTypeList() {
      return this.dictParseList(CARDICT.CAR_TYPE_DICT())
    },
    // 采购方式
    procurementList() {
      return this.dictParseList(CARDICT.CAR_PROCUREMENT_DICT())
    },
    // 颜色列表
    colorList() {
      return this.dictParseList(CARDICT.CAR_COLOR_DICT())
    },
    // 使用性质
    useList() {
      return this.dictParseList(CARDICT.CAR_USE_DICT())
    },
    // 车辆属性
    attrubuteList() {
      return this.dictParseList(CARDICT.CAR_ATTRIBUTE_DICT())
    },
    // 加粗标红
    RedBlod() {
      return (props) => {
        const field = this.carColor.find((item) => item.props === props)
        return field?.state === 1 ? 'create-car-blod' : ''
      }
    },
    rentStandard() {
      const filterArr = this.carColor.filter((item) => Number(item.state) === 1)
      if (!this.carInfo.modelId || !this.carInfo.vin) {
        return false
      }
      if (filterArr.length === 0) {
        return true
      }
      let sum = 0
      filterArr.forEach((item) => {
        if (item.parentKey) {
          // 因为图片是数组所以需要判断长度
          const isArray = this[item.parentKey][item.props] instanceof Array
          if (isArray) {
            if (this[item.parentKey][item.props].length) {
              sum++
            }
          } else if (
            this[item.parentKey][item.props] ||
            this[item.parentKey][item.props] === 0
          ) {
            sum++
          }
        } else {
          // 因为图片是数组所以需要判断长度
          const isArray = this[item.props] instanceof Array
          if (isArray) {
            if (this[item.props].length) {
              sum++
            }
          } else if (this[item.props] || this[item.props] === 0) {
            sum++
          }
        }
      })
      if (sum === filterArr.length) {
        return true
      } else {
        return false
      }
    },
    // 车辆外观状态
    appearanceList() {
      return this.dictParseList(CARDICT.CAR_APPEARANCE_DICT())
    },
    // 车辆底盘状态
    chassisList() {
      return this.dictParseList(CARDICT.CAR_CHASSIS_DICT())
    },
  },
}
</script>
<style scoped lang="scss">
.tar {
  text-align: right;
}
.create-car {
  ::v-deep .el-input--small {
    width: 205px;
  }
  ::v-deep .el-collapse {
    margin-top: -30px;
    border-top: none;
  }
  ::v-deep .el-collapse-item__content {
    padding-top: 25px;
  }
  ::v-deep .el-collapse-item__wrap {
    border-bottom: none;
    overflow: auto !important;
    padding-bottom: 16px;
  }
  ::v-deep .el-collapse-item__arrow.is-active {
    transform: rotate(-90deg);
  }
  ::v-deep .el-collapse-item__arrow {
    transform: rotate(90deg);
  }
  .car-info {
    .zitem-box {
      .content {
        display: flex;
      }
    }
  }
  .zitem-box {
    margin-bottom: 20px;
    .zitem {
      display: flex;
      .label {
        padding: 0 12px;
        width: 150px;
        max-width: 600px;
        line-height: 26px;
        font-size: 14px;
        color: #323233;
        box-sizing: border-box;
      }
      .content {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        &.w520 {
          max-width: 520px;
          .upload-box {
            float: left;
          }
        }
        &.w590 {
          max-width: 590px;
          .upload-box {
            float: left;
          }
        }
        .citem {
          display: flex;
          .map {
            width: 128px;
            img {
              display: block;
              width: auto;
              height: 96px;
            }
            .txt {
              margin-top: 8px;
              padding: 0;
              text-align: center;
              font-size: 14px;
              color: #969799;
              line-height: 25px;
            }
          }
        }
      }
    }
  }
  // 加红加粗
  ::v-deep .create-car-blod {
    .el-form-item__label,
    .el-upload__tip {
      font-weight: bold;
      color: red !important;
    }
  }
  .car-info {
    padding-top: 12px;
  }
  .sumbit-btns {
    text-align: center;
  }
  .car_remarks {
    ::v-deep .el-form-item__content {
      display: -webkit-box;
    }
    .remark_content {
      margin-left: 20px;
    }
  }
}
::v-deep .brand-series-item {
  display: flex;
  .el-form-item__label {
    font-weight: bold;
    color: red !important;
  }
}
::v-deep .model-item {
  display: flex;
  .el-form-item__label {
    font-weight: bold;
    color: red !important;
  }
}
</style>
